<template>
  <div class="formPrintList">
    <slot></slot>
    <div class="collectContent" style="min-height: 7rem">
      <div class="tabs means-head-tit" v-if="isShowNav">
        <h3 class="tab">
          <img src="@img/oldCode/title-icon.png"/>
          表单打印
        </h3>
        <el-radio-group v-model="PRINT_CHANNEL" class="channels">
          <el-radio label="1" class="print-single">见证办理</el-radio>
          <el-radio label="2" class="print-single">临柜办理</el-radio>
        </el-radio-group>
        <a href="javascript:void(0);" class="printBtn btn" @click="openCheckImgList('1')">
          <img src="@img/newCode/formPrint/iconSVG-.png" />
          批量打印
        </a>
        <a href="javascript:void(0);" class="downBtn btn" @click="openCheckImgList('2')">
          <img src="@img/newCode/formPrint/download.png" />
          批量下载
        </a>
        <a href="javascript:void(0);" class="btn" @click="emailSendCon()">
          <img src="@img/newCode/formPrint/email.jpg" />
          邮件发送
        </a>
      </div>
      <div class="print_list uploadContent">
        <template v-for="(item, index) in formItemItems">
          <!-- <div :key="index + item.IMG_CLS_NAME" class="print_row">
            <div class="print_item">
              <h3>{{ item.IMG_CLS_NAME }}</h3>
              <a href="javascript:void(0);" class="btn" @click="printPdfClick(item)">打印</a>
              <div class="tip" :class="{ comp: item.printStatus == 1, notComp: item.printStatus != 1 }">
                {{ item.RESET_FLAG == "1" ? "重新打印" :  item.printStatus == 1 ? "已打印" : "未打印" }}
              </div>
            </div>
          </div> -->
          <div class="collect-item" :key="index + item.IMG_CLS">
            <img-upload
              upload-text="打印"
              :ref="'FORM_FILE_' + index"
              :upload-flag=false
              :title="item.IMG_CLS_NAME"
              :active=true
              :tip="item.RESET_FLAG=='1'?'重新打印':item.printStatus==1?'已打印':'未打印'"
              :color="item.printStatus == 1 ? '#419a4b':'#f94444'"
              @uploadModal="printPdfClick(item)"
            />  
          </div>
        </template>
      </div>
    </div>
    <check-img-list v-if="isShowPrint" :formList="formItemItems" :title="PRINT_DOWN_CON_FLAG =='2' ? '批量下载' : '批量打印'" :btnText="PRINT_DOWN_CON_FLAG =='2' ? '批量下载' : '批量打印'" 
      @confirmBtnHandler="batchPrintClick" @closeImgList="closeImgList"></check-img-list>
    <div class="fixed_btn operator-footer-btn-group">
      <el-button @click="goPrev"  id="videoPrevBtn" class="button light-button">上一步</el-button>
      <el-button type="button" class="button light-button-save" @click="handleSubmit">下一步 </el-button>
    </div>
    <send-email v-if="isShowEmail" @sendEmailMsg="sendEmailMsg" @closeEmail="closeEmail"></send-email>
    <div id="qrcodeCanvas" style="display: none"></div>
  </div>
</template>

<script>
import flowTip from "@/components/common/flowTip";
import { imgCommonMixins } from "./child/imgCommonMixins";
import oppService from "@/service/opp-service";
import sendEmail from "./child/sendEmail";
import checkImgList from "./child/checkImgList";
import imgTools from "./child/imgTools";
import templateAndData from "./child/template-and-data";
import { PDFDocument } from "pdf-lib";
// import JsBarcode from "jsbarcode";
import QRCode from "qrcodejs2";
import JSZip from "jszip";
import FileSaver from "file-saver";
import imgUpload from "./child/upload";
export default {

  data () {
    return {
      imgStyleText: "请拍摄上传以下开户所需的影像材料:",
      ocrIImgtems: [], //ocr识别采集
      faceImgItems: [], //免冠照
      recoveryArr: [], //当前业务需要回收的影像
      custInfo: "", //客户信息
      userInfo: "", //柜员信息
      pdfImgCls: ["XbQ"], //需要打印pdf的影像类别,pdf来自于影像系统
      paltformClass: "",
      initFinish: false,
      isTest: false, //测试开关
      imgClsArr: [], //所有影像类别
      collectImgItems: [], //影像上传节点
      reUploadImgItems: [], //影像补采列表
      eSignSealItems: [], //签名盖章列表
      formItemItems: [], //打印表单
      otherItem: [], //其他隐藏表单
      PRINT_CHANNEL: "1", //选择打印的渠道
      PRINT_DOWN_CON_FLAG: "", //打印和下载标记  1-批量打印 2-批量下载
      IMG_CLS_NAME_INFO: {}, //影像类别与影像名称对应列表，用于批量下载文件命名
      isShowPrint: false,//批量打印弹窗
      isShowEmail: false,
      checkPrintImgClsArr: [],//勾选需要批量打印的影像
      batchGetTpl: [],//根据勾选框批量获取影像系统的pdf
      batchPrintPdf: [],//添加二维码的批量打印的pdf
      ignoreImgCls: ["050","071","x9999"],
    };
  },
  components: {
    flowTip,
    checkImgList,
    sendEmail,
    imgUpload
  },
  props: ["bizData", "historyData", "oppBusiData", "qrCodeType", "maxApptStatus", "isShowNav", "isDisabled"],
  mixins: [imgCommonMixins],
  async created () {
    // this.setData();
    let that = this;
    //根据公参配置是否显示跳过按钮
    that.isTest = await oppService.getSysCommonParamsFromCacheObjs("IS_FXC_TEST");
    that.initPage();
  },
  mounted () {
    if(this.$syscfg.isOpenAcctBiz(this.busiCode)){
      this.alert("请分支机构自行准备《三方存管协议》文件给客户签署!");
    }
    //流程状态 17-已转移到VTM、18-已转移到一站通，默认勾选 临柜开户
    if (["17", "18"].includes(this.apptStatus.toString())) {
      this.PRINT_CHANNEL = "2";
    } else {
      this.PRINT_CHANNEL = "1";
    }
  },
  activated (){
    this.renderPrintStatus();
  },
  methods: {
    goPrev (){
      consoleLog("formPrintList goPrev");
      this.$router.goPrev();
    },
    initPage (){
      //初始化 ，刷新页面，
      let that = this;
      that.$store.commit(that.$types.UPDATE_LOADING, "正在查询影像数据...");
      that.assembusiData(true, this.ignoreImgCls).then(res => {
        consoleLog("formPrintList影像初始化完成");
        that.initFinish = true;
        that.renderPrintStatus();
        that.$store.commit(that.$types.UPDATE_LOADING, false);
      });
    },
    //关闭选择影像组件
    closeImgList () {
      this.isShowPrint = false;
    },
    //关闭发送邮箱弹窗
    closeEmail () {
      this.isShowEmail = false;
    },
    imageValid () {
      if (!this.$store.state.permission.editAuth) {
        this.alert("您无权操作，请先申请权限");
        return false;
      }
      return true;
    },
    //回填表单套打状态
    renderPrintStatus () {
      let that = this;
      _.each(this.formItemItems, (formObj, index)=>{
        formObj.printStatus = formObj.PRINT_STATUS || "0";
        that.$set(that.formItemItems, index, formObj);
      });
    },
    async printPdfClick (item) {
      let that = this;
      if (!this.imageValid()) {
        return false;
      }
      //点击打印之后，需要把已打印的状态值给改了
      _.each(this.formItemItems, (formObj, index)=>{
        if(item.IMG_CLS == formObj.IMG_CLS){
          formObj.PRINT_STATUS = "1";
          formObj.printStatus = formObj.PRINT_STATUS || "1";
          formObj.RESET_FLAG = "0";
          that.$set(that.formItemItems, index, formObj);
        }
      });    
      this.getPdfTpl(item);
    },
    //获取打印的pdf文件
    async getPdfTpl (item, isGetAll) {
      let busiData = this.historyData;
      let imgCls = item.IMG_CLS;
      let templateObj = await templateAndData.getTemplateData({
        B_SNO: this.bSno,
        CUST_CODE: busiData.CUST_CODE,
        USER_TYPE: busiData.USER_TYPE,
        imgClsList: [imgCls],
        IMG_CLS_NAME: item.IMG_CLS_NAME,
        openAcctType: this.openAcctType,
        BUSI_CODE: this.busiCode
      });
      //将影像类别标记为已打印
      await this.$syscfg.K_Request("F0000037", {
        SERVICE_CODE: "D7700058",
        B_SNO: this.$store.state.oldBizData.KIDM_SNO,
        IMG_CLS: imgCls,
        BUSI_CODE: this.busiCode,
        ACCEPT_PARAM: JSON.stringify(templateObj.templateData),
      });

      if (this.pdfImgCls.includes(imgCls)) {
        let data = {
          IMG_CLS: imgCls,
          BIZ_DATA: templateObj.templateData,
          USER_TYPE: this.userType,
          BUSI_CODE: this.busiCode,
          // openAcctType:"1",
        };
        //获取影像系统pdf文件【影像样本设置】
        let res = await this.$syscfg.K_Request("F0000055", data);
        // IMG_DATA后台返回的base64的 文件流
        if (res.Data) {
          if(isGetAll){
            //批量打印 批量下载 直接返回结果
            return res.Data[0];
          }
          //单独的打印 需要渲染页面
          this.previewPdf(res.Data[0].IMG_DATA, imgCls);
        }
      } else {
        // OPPCP-24276 需求优化  获取影像系统电子模板【临柜模板设置】
        let res2 = await this.$syscfg.K_Request("F0000056", {
          IMG_CLS: imgCls,
          APPT_SN: this.apptSn,
          PRINT_CHANNEL: this.PRINT_CHANNEL,
          BIZ_DATA: templateObj.templateData,
          // openAcctType:"1",
          USER_TYPE: this.userType,
          BUSI_CODE: this.busiCode,
          B_SNO: this.$store.state.oldBizData.KIDM_SNO,
        });
        // IMG_DATA后台返回的base64的 文件流
        if (res2.Code == 0) {
          if(isGetAll){
            //批量打印 批量下载 直接返回结果
            return res2.Data[0];
          }
          this.previewPdf(res2.Data[0].IMG_DATA, imgCls);
        } else {
          this.alert(res2.Msg);
        }
      }
    },
    base64ToBlob (src) {
      let base64Str = "data:application/pdf;base64," + src.replace(/:(.*?),/, "");
      return imgTools.base64ImgtoFile(base64Str);
    },
    //批量打印 预览、打印pdf
    previewBatchPdf (pdfUrl) {
      this.previewPdf(pdfUrl);
      this.batchPrintPdf = [];
    },
    //预览、打印pdf
    previewPdf (pdfUrl, imgCls) {
      if(!_.startsWith(pdfUrl, "blob:")){
        let fileBlob = this.base64ToBlob(pdfUrl, "application/pdf");
        pdfUrl = window.URL.createObjectURL(fileBlob);
      }
      window.open(pdfUrl, "表单打印", "width=1024,height=800,top = 200, left=400,menubar=no,toolbar=no, status=no,scrollbars=yes");
    },
    //修改表单套打状态
    async batchPrintStatus (imgCls) {
      for (let i = 0; i < this.formItemItems.length; i++) {
        if (imgCls.includes(this.formItemItems[i].IMG_CLS)) {
          this.formItemItems[i].printStatus = 1;
          this.$set(this.formItemItems, i, this.formItemItems[i]);
        }
      }
    },
    //打开批量打印弹框 批量下载弹窗
    openCheckImgList (flag) {
      if (!this.imageValid()) {
        return false;
      }
      //显示弹窗
      this.isShowPrint = true;
      this.PRINT_DOWN_CON_FLAG = flag;
    },
    //点击批量打印 批量下载
    async batchPrintClick (printList, cb) {
      let that = this;
      this.checkPrintImgClsArr = printList;
      if(!this.checkPrintImgClsArr.length){
        let str = this.PRINT_DOWN_CON_FLAG == "2" ? "下载" : "打印";
        this.alert("请选择要进行批量"+ str +"的影像");
        //阻止关闭弹窗
        cb(false);
        return;
      }
      //重新点击批量打印，清空
      this.batchPrintPdf = [];
      this.$store.commit(this.$types.UPDATE_LOADING, this.PRINT_DOWN_CON_FLAG == "2" ? "正在批量下载中..." : "正在批量打印中...");
      this.batchGetTpl = await this.getAllPdfTpl();
      let imgClsList = [];
      //循环处理表单
      for(let i = 0; i < this.batchGetTpl.length; i++){
        let item = this.batchGetTpl[i];
        //更新界面打印状态
        for (let i = 0; i < that.formItemItems.length; i++) {
          if(this.formItemItems[i].IMG_CLS == item.IMG_CLS) {
            item.IMG_CLS_NAME =  that.formItemItems[i].IMG_CLS_NAME;
          }
        }
        imgClsList.push(item.IMG_CLS);
        try{
          //为pdf文件添加二维码
          let barCodeFile = await that.addBarCode(item.IMG_DATA, item.IMG_CLS, item.IMG_CLS_NAME);
          //存储已经添加二维码的PDF，用于多个pdf拼接
          that.batchPrintPdf.push(barCodeFile);
          //全部添加完二维码之后，多个pdf拼接
          if(that.batchPrintPdf.length == that.batchGetTpl.length){
            that.PRINT_DOWN_CON_FLAG == "2" ? that.downLoadPdf() : that.joinPdf();
            that.modelPrintClose = false;
            //一次性更新表单的打印状态
            that.batchPrintStatus(imgClsList);
            that.$store.commit(that.$types.UPDATE_LOADING, false);
            that.closeImgList();
          }
        }catch(err){
          consoleLog(err);
          this.alert(err.toString());
          //阻止关闭弹窗
          cb(false);
        }
      }
    },
    //一次性获取批量打印勾选的影像系统所有pdf
    getAllPdfTpl (){
      let reqArr = [];
      let tmpTpl= [];
      this.checkPrintImgClsArr.forEach((item,index)=>{
        let params = {
          IMG_CLS: item.IMG_CLS,
          IMG_CLS_NAME: item.IMG_CLS_NAME,
        };
          //getImgClsPDF XbQ 获取影像系统pdf文件【影像样本设置】,  getSignTpl 获取影像系统电子模板【临柜模板设置】
        reqArr[index] = this.getPdfTpl(params, true);
      });
      return Promise.all(reqArr).then(resArr => {
        for(let i=0,l=resArr.length;i<l;i++) {
          let res = resArr[i];
          if(res) {
            tmpTpl.push({IMG_DATA: res.IMG_DATA, IMG_CLS: res.IMG_CLS});
          }
        }
        return tmpTpl;
      }).catch(err => {
        this.modelPrintClose = false;
        this.modelEmailClose = false;
        this.alert("获取获取表单模版失败",err.toString());
        consoleLog("获取获取表单模版失败", err.toString());
        throw "获取获取表单模版失败"+err.toString();
      });
    },
    //批量下载
    async downLoadPdf () {
      let downUrlArr = this.batchPrintPdf;
      const zip = new JSZip();
      downUrlArr.forEach((obj,i)=>{
        const file_name = obj.IMG_CLS_NAME +".pdf";//文件名
        const file = obj.fileData;
        let fileBlob = this.base64ToBlob(file.split(",")[1], "application/pdf");
        zip.file(file_name, fileBlob, {binary:true});
      });
      const content = await zip.generateAsync({type: "blob"});
      FileSaver.saveAs(content,"批量打印表单"+this.bSno);
    },
    // 拼接pdf
    joinPdf () {
      let pdfUrlArr = this.batchPrintPdf;
      let that = this;
      PDFDocument.create().then(function (mergePdf) {
        let drgree = 0;
        pdfUrlArr.forEach((obj, i)=>{
          PDFDocument.load(obj.fileData).then(function (pdfDoc) {
            mergePdf.copyPages(pdfDoc, pdfDoc.getPageIndices()).then(function (pdfPage) {
              drgree++;
              pdfPage.forEach(function (page) {
                mergePdf.addPage(page);
              });
              if(pdfPage.length%2 === 1){
                //奇数页添加一个空白页 防止双面打印的时候，不同类别的影像打印在同一张纸
                mergePdf.addPage();
              }
              if (drgree === pdfUrlArr.length) {
                mergePdf.save().then(function (pdfDataBytes) {
                  var pdfDataBlob = new Blob([pdfDataBytes], {
                    type: "application/pdf"
                  });
                  var pdfUrl = URL.createObjectURL(pdfDataBlob);
                  that.previewBatchPdf(pdfUrl);
                });
              }
            });
          });
        });
      });
    },
    //为PDF添加二维码
    async addBarCode (fileBasePdf, imgCls, imgClsName) {
      let data = {
        IMG_CLS: imgCls
      };
      this.$store.commit(this.$types.UPDATE_LOADING, `正在生成表单${imgClsName}二维码`);
      consoleLog( `正在生成表单${imgClsName}二维码`);
      //获取影像类别对应的二维码号 影像系统【影像条形码设置】
      let resBarCode = await this.$syscfg.K_Request("F0000057", data);
      const pdfDoc = await PDFDocument.load(fileBasePdf);
      const pages = pdfDoc.getPages();
      let BAR_CODE_SNO = "";
      //查询到二维码号则添加条形码，否则不添加
      if(resBarCode.Code == "0") {
        BAR_CODE_SNO = resBarCode.Data[0].BAR_CODE_SNO;
        // let img = document.createElement("img");
        for(let i =0;i<pages.length;i++){
          //XbQ-开户文件，最后一页才添加二维码
          if((imgCls == "XbQ" && i > (pages.length-2)) || imgCls != "XbQ"){
            this.$store.commit(this.$types.UPDATE_LOADING, `正在处理表单${imgClsName}-${i+1}`);
            consoleLog(`正在处理表单${imgClsName}-${i+1}`);
            // 使用 QRCode 实例化二维码
            let base64String = await this.generateQRCode(BAR_CODE_SNO+"_"+ (i+1));
            if(!base64String){
              throw "二维码生成失败，请重试！";
            }
            const pngImage = await pdfDoc.embedPng(base64String);
            let width = 70;
            if(["010","X1C","04x"].includes(imgCls)){
              width = 45;
            }
            pages[i].drawImage(pngImage, {
            // x: pages[i].getWidth()-162,
            // y: pages[i].getHeight()-27,
            // width: 150,
            // height: 15,
              x: pages[i].getWidth()-width-5,
              y: pages[i].getHeight()-width-5,
              width: width,
              height: width,
            });
          }
        }
      }
      const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      return {fileData: pdfDataUri, IMG_CLS: imgCls, IMG_CLS_NAME: imgClsName};
    },
    // 创建一个异步函数来生成二维码并获取 Base64 数据
    generateQRCode (text) {
      return new Promise((resolve, reject) => {
        // 创建一个用于存放二维码的 canvas 元素
        let canvas = document.getElementById("qrcodeCanvas");
        canvas.innerHTML = "";
        // 生成二维码的配置对象
        let options = {
          text: text,
          width: 256,
          height: 256,
          colorDark: "#000000",
          colorLight: "#ffffff",
          // 容错率  从低到高依次为LMQH,越高生成得二维码越密 
          correctLevel: QRCode.CorrectLevel.H
        };
        consoleLog("生成二维码,text==",text);
        // 使用 qrcodejs2 库生成二维码
        const qrCode = new QRCode(canvas, options);
        let tmpTimer = setInterval(() => {
          // 获取二维码的 Base64 编码
          const base64 = canvas.childNodes[1].src;
          if(base64){
            consoleLog("获取base64成功"); // 打印 Base64 编码
            qrCode.clear();
            clearInterval(tmpTimer);
            resolve(base64);
          }
        }, 500);
      });
    },
    //邮件发送弹框
    emailSendCon () {
      this.isShowEmail = true;
    },
    //邮箱发送
    async sendEmailMsg (email) {
      if(!this.imageValid()){
        return false;
      }
      let imgCLsList = [];
      let IMG_LIST = [];
      this.formItemItems.forEach(item=>{
        imgCLsList.push(item.IMG_CLS);
        IMG_LIST.push({
          IMG_CLS: item.IMG_CLS,
          IMG_CLS_NAME: item.IMG_CLS_NAME,
        });
      });
      this.$store.commit(this.$types.UPDATE_LOADING, "正在处理表单中...");
      let busiData = this.historyData;
      let templateObj = await templateAndData.getTemplateData({
        B_SNO: this.bSno,
        CUST_CODE: busiData.CUST_CODE,
        USER_TYPE: busiData.USER_TYPE,
        imgClsList: imgCLsList,
        openAcctType: this.openAcctType,
        BUSI_CODE: this.busiCode
      });

      let parmas = {
        APPT_SN: this.apptSn,
        openAccType: this.openAcctType,
        USER_TYPE: this.userType,
        BUSI_CODE: this.busiCode,
        EMAIL: email,
        IMG_LIST: IMG_LIST,
        PRINT_CHANNEL: this.PRINT_CHANNEL,
        BIZ_DATA: templateObj.templateData,
        B_SNO: this.$store.state.oldBizData.KIDM_SNO,//影像流水号
      };
      this.$store.commit(this.$types.UPDATE_LOADING, "正在发送邮件...");
      let res = await this.$syscfg.K_Request("F0000058", parmas);
      if (res.Code == 0) {
        //更新界面打印状态
        for (let i = 0; i < this.formItemItems.length; i++) {
          this.formItemItems[i].printStatus = 1;
        }
        this.batchPrintStatus(imgCLsList);
        this.alert("邮件发送成功！");
      } else {
        this.alert("邮件发送失败！提示信息：" + res.Msg);
      }
      this.$store.commit(this.$types.UPDATE_LOADING, false);
    },
    handleSubmit () {
      consoleLog("handleSubmit formPrintList");
      let validateRes = this.validate();
      if(!validateRes){
        console.error("进入了页面");
        return;
      }
      this.$router.goNext(); 
    },
    validate () {
      if(this.isDisabled){
        //页面禁用，说明不需要校验
        return true;
      }
      let flag = true;
      for (let i = 0; i < this.formItemItems.length; i++) {
        if (this.formItemItems[i].printStatus === "0") {
          this.alert("请将表单打印完成！");
          flag = false;
        }
      }
      return flag;
    },
    skipToNext () {
      this.$router.goNext();
    }
  },
  computed: {
    busiCode () {
      return this.$store.state.busicode;
    },
    userType () {
      return this.$store.state.usertype;
    },
    busiName () {
      return this.$store.state.busiName;
    },
    bSno () {
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
    apptSn () {
      return this.$store.state.apptSn;
    },
    apptStatus () {
      return this.$store.state.apptStatus;
    },
    openAcctType () {
      return this.$store.state.openAcctType;
    }
  },
  watch: {
    // showLoading (v) {
    //   if (v) {
    //     this.myLoading({
    //       loadingText: "即将进入影像采集环节&请稍候...",
    //       autoHide: false
    //     });
    //   } else {
    //     this.myLoading({
    //       showLoading: false
    //     });
    //   }
    // }
  }
};
</script>

<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.formPrintList {
  width: 100%;
  height: 100%;
  position: relative;
  .collectContent {
    padding: 24px;
    background: #ffffff;
    border-radius: 5px;
    margin-top: 2px;
    padding-bottom: 0.8rem;
    .tabs {
      display: flex;
      height: 0.5rem;
      font-size: 18px;
      background: #f6f7f9;
      margin-bottom: 0.24rem;
      line-height: 0.5rem;
      position: relative;
      align-items: center;
      justify-content: flex-end;
      .tab{
        .fontsize-title-small();
        position: absolute;
        left: 8px;
      }
      .btn{
        .fontsize-btn-medium();
        position: relative;
        right: 0;
        margin-right: 24px;
      }
      .channels{
        // position: absolute;
        // right: 4rem;
        margin-right: 24px;
        /deep/ .el-radio__label{
          color: #d0aa72 !important;
        }
      }
      .printBtn {
        // right: 3.2rem;
      }
      .downBtn {
        // right: 1.8rem;
      }
    }
    .el-radio {
      line-height: 50px;
      margin-left: 20px;
    }
    .uploadContent{
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 60px;
      min-height: 3rem;
      width: 100%;
      overflow-y: auto;
      padding-left: 5%;
      .collect-item{
        padding:0 50px;
        width: 50%;
      }
    }
    // .print_list {
    //   padding: 0.13rem 0.31rem;
    //   display: flex;
    //   flex-wrap: wrap;
    //   .print_row {
    //     display: block;
    //     width: 50%;
    //     float: left;
    //   }
    //   .print_item {
    //     width: 5rem;
    //     height: 0.8rem;
    //     line-height: 0.8rem;
    //     background: #f6f7f9;
    //     border: 0.5px solid #ebeef3;
    //     border-radius: 5px;
    //     box-sizing: border-box;
    //     padding: 0 0.19rem;
    //     position: relative;
    //     margin-bottom: 0.4rem;
    //     h3 {
    //       font-size: 0.16rem;
    //       font-weight: normal;
    //       display: flex;
    //       align-items: center;
    //       width: 3.5rem;
    //       height: 100%;
    //       line-height: normal;
    //     }
    //     .btn {
    //       width: 1.1rem;
    //       height: 0.8rem;
    //       position: absolute;
    //       right: 0;
    //       top: 0;
    //       border-radius: 5px;
    //       background: #d0aa72;
    //       text-align: center;
    //       line-height: 0.8rem;
    //       font-size: 0.16rem;
    //       color: #ffffff;
    //       box-sizing: border-box;
    //     }
    //     .tip {
    //       position: absolute;
    //       font-size: 0.14rem;
    //       line-height: 0.14rem;
    //       margin-top: 0.11rem;
    //       width: 100%;
    //       left: 0;
    //       padding: 0 0.19rem;
    //     }
    //     .tip:before {
    //       content: "*";
    //       margin-right: 4px;
    //       font-size: 14px;
    //       line-height: 6px;
    //       padding-top: 5px;
    //       position: absolute;
    //       left: 0;
    //     }
    //     .tip.notComp {
    //       color: #f94444;
    //     }
    //     .tip.comp {
    //       color: #419a4b;
    //     }
    //   }
    // }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/formPrintList.vue